<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="date">Дата и время</label>
    <el-date-picker
      input-id="date"
      input-class="form-control"
      type="datetime"
      placeholder="Выберите дату и время"
      v-model="localValue">
    </el-date-picker>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'date-time-field',
  props: {
    value: [String, Number, Date],
    error: Array
  },
  data () {
    return {
      localValue: new Date()
    }
  },
  mounted () {
    this.localValue = this.value
  },
  watch: {
    value: function (val) {
      this.localValue = val
    },
    localValue: function (val) {
      this.updateValue(val)
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// DateTime.vue?11875db8